import { days_to_ms, get_date_ignoreTimezone } from "../util/general_util";
import { Campground_Data, Trip_Cluster_v2, tripPlanner_reservation_data, tripPlannerReservationEvent } from "../util/tripPlanner_types";
import { InstantBookSettings } from "../util/type_defs";
import { add_membership, get_customer_token, make_reservation, update_s2n_client } from "./instantBook_api";
import { get_reserve_settings, handle_instant_book_form_submit, init_checkout, setGuests, setVehicle } from "./instantBook_scripts";
import { display_pre_checkout } from "./instantBook_ui_scripts";

export function init_instantBook_listeners(is_tripPlanner:boolean) {
    let campID:number|null = null;
    let legIndex:number|null = null;
    let stopIndex:number|null = null;
    let stop:Trip_Cluster_v2|null = null;
    let stay:Campground_Data|null = null;

    if (is_tripPlanner) {
        $("#cgCardInstantBookButton").off("click");
        $("#cgCardInstantBookButton").on("click", function() {
            campID = parseInt($('#campExpandedModal #info').attr("campID"));
            legIndex = parseInt($('#campExpandedModal #info').attr("leg"));
            stopIndex = parseInt($('#campExpandedModal #info').attr("stop"));

            if (!Number.isNaN(legIndex) && !Number.isNaN(stopIndex)) {
                stop = window.tripPlannerCurrentTrip.legs[legIndex].clusters[stopIndex];

                if (stop.s_date != undefined && stop.numNights != undefined && stop.numNights != null) {
                    const startDate:Date = get_date_ignoreTimezone(stop.s_date);
                    const endDate:Date = new Date(startDate.getTime() + days_to_ms(stop.numNights));
                    window.instantBoook_Date_pickr.setDate([startDate,endDate])
                } else if (stop.selectedCamps.length > 0) {
                    for (let i:number = 0; i < stop.selectedCamps.length; i++) {
                        if (stop.selectedCamps[i].camp.campID == campID) {
                            stay = stop.selectedCamps[i];
                            if (stay.s_date != undefined && stay.numNights != undefined && stay.numNights != null) {
                                const startDate:Date = get_date_ignoreTimezone(stay.s_date);
                                const endDate:Date = new Date(startDate.getTime() + days_to_ms(stay.numNights));
                                window.instantBoook_Date_pickr.setDate([startDate,endDate])
                            };
                            break;
                        };
                    };
                };
            };

        });
    };

    $(".showCampInfoBtn").off("click");
    $(".showCampInfoBtn").on("click",function() {
        $(".showCampInfoBtn").addClass("d-none");

        $('#leftContainercomponents').removeClass('d-none');

        if (!($('#cgCardReserve').hasClass("d-none"))) $('#cgCardReserve').addClass("d-none");
        if (!($('#cgCardCheckout').hasClass("d-none"))) $('#cgCardCheckout').addClass("d-none");

        if ($("#instantBookForm").hasClass("d-none")) {
            $("#instantBookForm").removeClass("d-none");
        }
    });

    $("#instantBookForm").off("submit");
    $("#instantBookForm").on("submit", handle_instant_book_form_submit);

    $("[setVehicle]").off("click")
    $("[setVehicle]").on("click", function(event) {
        event.preventDefault();
        $("#rvDropdown").find("[data-bs-toggle='dropdown']").dropdown("hide");
        const vehicleChange:boolean = setVehicle();

        if (vehicleChange && !($("#cgCardReserve").hasClass("d-none"))) {
            $("#instantBookForm").trigger("submit");
        };
    });

    $("#rvDropdown").find("[data-bs-toggle='dropdown']").off("hide.bs.dropdown");
    $("#rvDropdown").find("[data-bs-toggle='dropdown']").on("hide.bs.dropdown", function() {
        const vehicleChanged:boolean = setVehicle();
        if (vehicleChanged) $("#instantBookForm").trigger("submit");
    });

    $("#guestsDropdwon").find("[data-bs-toggle='dropdown']").off("hide.bs.dropdown");
    $("#guestsDropdwon").find("[data-bs-toggle='dropdown']").on("hide.bs.dropdown", function() {
        const guestsChanged:boolean = setGuests();
        if (guestsChanged) $("#instantBookForm").trigger("submit");
    });

    $("[get-reserve-quote]").off("click");
    $("[get-reserve-quote]").on("click", display_pre_checkout);

    $("[view-add-vehicle]").off("click");
    $("[view-add-vehicle]").on("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        $("#rvDropdown").find("[data-bs-toggle='dropdown']").dropdown("show")
    });

    $("#goToCheckout").off("click");
    $("#goToCheckout").on("click", function() {
        get_customer_token().then(customer_token => {
            init_checkout(customer_token,is_tripPlanner);
        }).catch(e => {
            if (e.message == "need_register_info") {
                $("#s2n_register_modal").modal("show");
            }
        });
    });

    $(".goToCheckout").off("click");
    $(".goToCheckout").on("click", function() {
        window.spotId = parseInt($(this).attr("spot_id"));
        get_customer_token().then(customer_token => {
            init_checkout(customer_token,is_tripPlanner);
        }).catch(e => {
            if (e.message == "need_register_info") {
                $("#s2n_register_modal").modal("show");             
            }
        });
    });

    $(".confirmPayCloseBtn").off("click");
    $(".confirmPayCloseBtn").on("click",function() {
        $("#confirmandpay_modal").modal("hide");
    });

    $("#completeCheckout").off("click");
    $("#completeCheckout").on("click", function() {
        const form:HTMLFormElement = document.getElementById("instantBookForm") as HTMLFormElement;
        const settings:InstantBookSettings = get_reserve_settings(form);
        const spotId:number = window.spotId;

        $("#completeCheckout").addClass("disabled");

        $("#paymentMethod_feedback").html("");
        $("#paymentMethod").removeClass("border-danger border border-3");

        make_reservation(spotId, settings).then(response => {
            $("#quoteDispNew").addClass("d-none");
            $("#reservationConfirmation").html(response.html);

            const eventData:tripPlanner_reservation_data = {
                legIndex: legIndex,
                stopIndex: stopIndex,
                campID: campID,
                s_date: settings.dates[0],
                e_date: settings.dates[1],
                reservationId: response.reservationId
            };
            const event = new tripPlannerReservationEvent(eventData);
            document.dispatchEvent(event);

        }).catch(e => {
            $("#completeCheckout").removeClass("disabled");
            if (e.message == "need_payment_method") {
                $("#paymentMethod_feedback").html("Please add payment method");
                $("#paymentMethod").addClass("border-danger border border-3");
            } else if (e.message == "not_available") {
                // $("#checkoutOffcanvas").offcanvas("hide");
                $("#confirmandpay_modal").modal("hide");
                $("#checkoutErrDisp").html("Spot is no longer available");
                $("#checkoutErrModal").modal("show");
            }
        });

    });

    $("#checkoutOffcanvas").off("hidden.bs.offcanvas");
    $("#checkoutOffcanvas").on("hidden.bs.offcanvas", function() {
        $("#reservationConfirmation").html("");
    });
    $("#confirmandpay_modal").off("hidden.bs.modal");
    $("#confirmandpay_modal").on("hidden.bs.modal", function() {
        $("#reservationConfirmation").html("");
    });

    $("#s2n_register_form").off("submit");
    $("#s2n_register_form").on("submit", function(event) {
        event.preventDefault();
        const form:JQuery<HTMLElement> = $(this);

        if (!(form[0] as HTMLFormElement).checkValidity()) {
            return;
        };
        update_s2n_client(form).then((response) => {
            $("#s2n_register_modal").modal("hide");
            $("#s2n_customer_info").html(response.html);
            init_checkout(response.token,is_tripPlanner);
        }).catch((e:Error) => {
            console.error(e);
            form.find("[s2n_infoUpdate_errMsg]").html(e.message);
        });
    });


    $("#s2n_customer_info").off("submit");
    $("#s2n_customer_info").on("submit", function(event) {
        event.preventDefault();

        const form:JQuery<HTMLElement> = $(this);

        if (!(form[0] as HTMLFormElement).checkValidity()) {
            return;
        };
        update_s2n_client(form).then((s2n_tok) => {
            // init_checkout(s2n_tok);
        }).catch((e:Error) => {
            console.error(e);
            form.find("[s2n_infoUpdate_errMsg]").html(e.message);
        });
    });

    $("[submitInstantBook]").off("click");
    $("[submitInstantBook]").on("click",function(event) {
        event.preventDefault();
        $("#instantBookForm").trigger("submit");
    });

    $("#confirmandpay_modal").off("shown.bs.modal");
    $("#confirmandpay_modal").on("shown.bs.modal", function() {
        $("#addCredentialsLink").off("click");
        $("#addCredentialsLink").on("click",function(event) {
            event.preventDefault();
            $("#addCredentialsLink").addClass("d-none");
            $("#discountfield").removeClass("d-none");

            $("form[addmembershipform]").off("submit");
            $("form[addmembershipform]").on("submit", function(event) {
                event.preventDefault();
                const membershipType:string = $(this).attr("membershipType");
                const membershipId:string = $(this).find(`#input-${membershipType}`).val().toString();

                add_membership(membershipType, membershipId).then(membershipDisplayHtml => {
                    $("#noMembershipsDisp").remove();
                    $("#customerMembershipsDisp").prepend(membershipDisplayHtml);
                }).catch(e => {
                    console.error(e);
                });
            });
        });
    });
};